import React, {useCallback, useEffect, useContext} from 'react';
import {Popup, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderNotifications.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo, faMegaphone, faExclamation} from "@fortawesome/pro-duotone-svg-icons";
import Empty from "../utils/Empty";
import {NetworkContext} from "../utils/NetworkContext";
import dayjs from "dayjs";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderNotifications({Dialog, dialog, notifications, setNotifications}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonRead = data => {
        if (!data.opened) {

            const message = {
                type: 'wss',
                path: 'notifications-read',
                action: 'update',
                data: {
                    item: data.id
                }
            };
            wsCall(message);
        }
    }

    const ListItem = data => {
        const itemDate = dayjs(parseInt(data.item.id)).format("MMMM D, YYYY @ h:mm A");

        return <li key={data.item.id} className="cs-dashboard-header-notifications-li" onClick={() => ButtonRead(data.item)}>
            <div className="mbsc-row cs-dashboard-header-notifications-list" >
                {data.item.type === 'info' &&
                    <FontAwesomeIcon className="cs-dashboard-header-notifications-icon" icon={faInfo} />
                }
                {data.item.type === 'announcement' &&
                    <FontAwesomeIcon className="cs-dashboard-header-notifications-icon" icon={faMegaphone} />
                }
                {data.item.type === 'error' &&
                    <FontAwesomeIcon className="cs-dashboard-header-notifications-icon" icon={faExclamation} />
                }
                <div className="cs-dashboard-header-notifications-list-section">
                    <div className={data.item.opened ? "mbsc-txt-muted" : "mbsc-bold mbsc-txt-muted"} >{data.item.title}</div>
                    <div className="mbsc-row mbsc-txt-s cs-dashboard-header-notifications-item-txt">
                        <span className="mbsc-txt-muted">{itemDate}</span>
                    </div>
                </div>
            </div>
        </li>;
    }

    const UpdateNotificationsRead = useCallback(data => {
        if (data.notifications) {
            data.notifications = data.notifications.reverse();
            setNotifications(data.notifications);
        }
    }, []);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'notifications-read') {
            UpdateNotificationsRead(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateNotificationsRead, setWsResponse]);

    return (
        <Popup className="cs-dashboard-header-notifications-popup" display="anchored" anchor={document.getElementById('dashboardHeaderNotifications')} showArrow={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderNotifications'} onClose={DialogClose} >
            <Listview
                theme="ios"
                themeVariant="light"
                select="single"
                itemType={ListItem}
                data={notifications}
            />
        </Popup>
    );
}

export default DashboardHeaderNotifications;
